import type { ChangeEvent } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import FormatCurrency from 'components/Common/FormatCurrency'
import { OfferFilterSelectButton, OfferFilterSelectButtonContent } from 'components/OfferPage/Filters/OfferFilterSelectButton'
import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import Switch from 'LuxKit/Switch/Switch'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  checked: boolean
  onChange: (checked: boolean) => void
  pricePerPerson?: number
}

function CruiseDepartureStayToggle({
  checked,
  onChange,
  pricePerPerson,
}: Props) {
  const intl = useIntl()
  const onToggle = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }, [onChange])

  return <OfferFilterSelectButton as="label">
    <LineBedDoubleIcon />
    <OfferFilterSelectButtonContent>
      <BodyText variant="medium" wrap="truncate">
        {intl.formatMessage({
          id: 'kAM9JQqLc-JLiCAAS9TZ',
          defaultMessage: 'Cruise + Hotel',
          description: 'Label for the hotel stay toggle beside the passenger selector above cruise departures',
        })}
      </BodyText>
      {pricePerPerson !== undefined && <Caption variant="medium" colour="light-foreground-alt">
        {intl.formatMessage({
          id: 'hZGn1hxoyusKGOypB7ql',
          defaultMessage: 'From {price}/person',
          description: 'Starting hotel stay price per person shown below the cruise departure stay toggle label',
        }, { price: <FormatCurrency value={pricePerPerson} format="rounded" /> })}
      </Caption>}
    </OfferFilterSelectButtonContent>
    <Switch checked={checked} onChange={onToggle} />
  </OfferFilterSelectButton>
}

export default CruiseDepartureStayToggle
